<template>
  <div>
    <form @submit.prevent="postMessage" name="contact" data-netlify="true" netlify-honeypot="bot-field" method="POST">
      <input type="hidden" name="form-name" value="contact" />
      <p class="hidden">
        don't fill this if you are human <input type="bot-field"/>
        <input type="text">
      </p>
      <div>
        <input class="inp w-full" autocomplete="off" :placeholder="$t('homepage.contact.contact_form.full_name')" name="full_name" v-model="full_name" type="text" />
      </div>
      <div class="mt-2">
        <input type="email" v-model="email" :placeholder="$t('homepage.contact.contact_form.email')" name="email" class="inp w-full" />
      </div>
      <div class="mt-2">
        <textarea :placeholder="$t('homepage.contact.contact_form.message')" class="inp w-full" name="message" v-model="message" cols="10"></textarea>
      </div>
      <div class="mt-1">
        <button :disabled="!valide" :class="valide ? 'btn-fill-animation' : 'btn-disabled'" class="btn btn-full" type="submit">
          <span><i class="fas fa-paper-plane pr-1"></i>send message</span>
        </button>
      </div>
    </form>
    <base-alert-modal v-show="showModal" @onCloseModal="showModal = false">
      <p><span class="font-family-8bit">{{ modalType }}</span> {{ modalMessage }}</p>
    </base-alert-modal>
  </div>
</template>

<script>
import { postContactMessage } from '../../api/contact.api'
import BaseAlertModal from '../base/modals/BaseAlertModal'

export default {
  name: 'ContactForm',
  components: { BaseAlertModal },
  data () {
    return {
      full_name: '',
      email: '',
      message: '',
      showModal: false,
      modalMessage: '',
      modalType: ''
    }
  },
  methods: {
    encode (data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&')
    },
    postMessage () {
      const data = {
        full_name: this.full_name,
        email: this.email,
        message: this.message,
        'form-name': 'contact'
      }
      postContactMessage(this.encode(data))
        .then(() => {
          this.showModal = true
          this.modalMessage = this.$i18n.t('homepage.contact.contact_form.modal.success')
          this.modalType = this.$i18n.t('modal.success')
        })
        .catch(() => {
          this.showModal = true
          this.modalMessage = this.$i18n.t('homepage.contact.contact_form.modal.alert')
          this.modalType = this.$i18n.t('modal.alert')
        })
    }
  },
  computed: {
    valide () {
      return this.full_name.length >= 4 && this.email.length >= 4 && this.message.length >= 30
    }
  }
}
</script>

<style scoped>

</style>
